var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCube5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.094,
    height: 61.413,
    viewBox: "0 0 46.094 61.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182755",
    "data-name": "\\uADF8\\uB8F9 182755",
    transform: "translate(-594.686 -183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182753",
    "data-name": "\\uADF8\\uB8F9 182753",
    transform: "translate(613.399 212.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182189",
    "data-name": "\\uADF8\\uB8F9 182189",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182187",
    "data-name": "\\uADF8\\uB8F9 182187",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130680",
    "data-name": "\\uD328\\uC2A4 130680",
    d: "M306.628,366l14.021,7.812V357.349l-14.021-7.812Z",
    transform: "translate(-306.628 -349.538)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182188",
    "data-name": "\\uADF8\\uB8F9 182188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130681",
    "data-name": "\\uD328\\uC2A4 130681",
    d: "M320.287,373.691a.233.233,0,0,1-.115-.03l-14.021-7.812a.239.239,0,0,1-.123-.208V349.177a.239.239,0,0,1,.355-.209L320.4,356.78a.239.239,0,0,1,.122.209v16.465a.237.237,0,0,1-.238.238ZM306.5,365.5l13.544,7.546V357.128L306.5,349.582Z",
    transform: "translate(-306.028 -348.939)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182192",
    "data-name": "\\uADF8\\uB8F9 182192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182190",
    "data-name": "\\uADF8\\uB8F9 182190",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130682",
    "data-name": "\\uD328\\uC2A4 130682",
    d: "M306.628,338.7l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-306.628 -331.527)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182191",
    "data-name": "\\uADF8\\uB8F9 182191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130683",
    "data-name": "\\uD328\\uC2A4 130683",
    d: "M320.37,346.4a.239.239,0,0,1-.116-.03l-14.1-7.826a.24.24,0,0,1-.123-.208.237.237,0,0,1,.122-.208l12.8-7.174a.237.237,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.416l-12.8,7.173A.24.24,0,0,1,320.37,346.4Zm-13.615-8.065,13.613,7.554,12.312-6.9-13.614-7.555Z",
    transform: "translate(-306.028 -330.927)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182195",
    "data-name": "\\uADF8\\uB8F9 182195",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182193",
    "data-name": "\\uADF8\\uB8F9 182193",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130684",
    "data-name": "\\uD328\\uC2A4 130684",
    d: "M355.2,368.214l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-342.581 -351.227)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182194",
    "data-name": "\\uADF8\\uB8F9 182194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130685",
    "data-name": "\\uD328\\uC2A4 130685",
    d: "M342.219,374.825a.239.239,0,0,1-.239-.239v-16.63a.239.239,0,0,1,.121-.208l12.622-7.091a.238.238,0,0,1,.354.208v16.987a.239.239,0,0,1-.126.211L342.33,374.8A.233.233,0,0,1,342.219,374.825Zm.238-16.729v16.093l12.144-6.48V351.273Zm12.383,9.756h0Z",
    transform: "translate(-341.98 -350.627)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182754",
    "data-name": "\\uADF8\\uB8F9 182754",
    transform: "translate(594.686 183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182209",
    "data-name": "\\uADF8\\uB8F9 182209",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182207",
    "data-name": "\\uADF8\\uB8F9 182207",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130692",
    "data-name": "\\uD328\\uC2A4 130692",
    d: "M259.521,292.024l14.021,7.812V283.371l-14.021-7.812Z",
    transform: "translate(-259.521 -275.559)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182208",
    "data-name": "\\uADF8\\uB8F9 182208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130693",
    "data-name": "\\uD328\\uC2A4 130693",
    d: "M273.18,299.712a.235.235,0,0,1-.116-.03l-14.021-7.812a.238.238,0,0,1-.122-.208V275.2a.238.238,0,0,1,.354-.208L273.3,282.8a.237.237,0,0,1,.123.208v16.465a.237.237,0,0,1-.238.238Zm-13.783-8.19,13.545,7.546V283.149L259.4,275.6Z",
    transform: "translate(-258.921 -274.959)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182212",
    "data-name": "\\uADF8\\uB8F9 182212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182210",
    "data-name": "\\uADF8\\uB8F9 182210",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130694",
    "data-name": "\\uD328\\uC2A4 130694",
    d: "M259.521,264.723l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-259.521 -257.549)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182211",
    "data-name": "\\uADF8\\uB8F9 182211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130695",
    "data-name": "\\uD328\\uC2A4 130695",
    d: "M273.262,272.426a.242.242,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.416l12.8-7.173a.239.239,0,0,1,.233,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.243.243,0,0,1,273.262,272.426Zm-13.614-8.065,13.614,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-258.921 -256.949)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182215",
    "data-name": "\\uADF8\\uB8F9 182215",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182213",
    "data-name": "\\uADF8\\uB8F9 182213",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130696",
    "data-name": "\\uD328\\uC2A4 130696",
    d: "M308.093,294.236l-12.622,6.734V284.34l12.622-7.091Z",
    transform: "translate(-295.472 -277.249)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182214",
    "data-name": "\\uADF8\\uB8F9 182214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130697",
    "data-name": "\\uD328\\uC2A4 130697",
    d: "M295.11,300.847a.239.239,0,0,1-.239-.238v-16.63a.237.237,0,0,1,.122-.208l12.621-7.091a.238.238,0,0,1,.356.208v16.987a.237.237,0,0,1-.127.211l-12.621,6.734A.242.242,0,0,1,295.11,300.847Zm.238-16.729v16.093l12.145-6.48V277.295Zm12.383,9.756h0Z",
    transform: "translate(-294.871 -276.649)",
    fill: "#111"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCube5);
export default __webpack_public_path__ + "static/media/information_cube5.b4bccf8295ccb6af863655de870852e9.svg";
export { ForwardRef as ReactComponent };